import React, { memo, ReactElement } from "react";
import { IColors } from "@swiggy-private/dls-web-common/dist/components/types";
import { PaymentMethodNameV4 } from "./v4";
export interface PaymentMethodNameProps {
    className?: string;
    displayName: string;
    id?: string;
    promoMsg?: string;
    dynamicPromoMsg?: JSX.Element | undefined;
    enabled: boolean;
    isNewBadgeEnabled?: boolean;
    ariaLabel?: string;
    "data-testid"?: string;
    discount?: string;
    discounts?: string[];
    payableAmount?: string;
    children?: ReactElement | ReactElement[] | undefined | Element | false;
    promoMsgClass?: string;
    subName?: string;
    isTurboPaymentMethod?: boolean;
    superScriptText?: string;
    color?: keyof IColors;
    recommended?: string;
}

function PaymentMethodName(props: PaymentMethodNameProps): ReactElement {
    return <PaymentMethodNameV4 {...props} />;
}

export default memo(PaymentMethodName);
